import moment from 'moment';

/**
 * @param {String|Boolean} featureToggleDate
 * @returns {Boolean}
 */
const isFeatureDateToggleEnabled = featureToggleDate => {
  try {
    return (
      featureToggleDate === true ||
      (featureToggleDate &&
        moment(featureToggleDate).isValid() &&
        moment().isAfter(moment(featureToggleDate)))
    );
  } catch (error) {
    return false;
  }
};

export default isFeatureDateToggleEnabled;
